import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Template } from 'src/app/models/template';
import { BaseEditForm } from 'src/app/shared/baseEditForm';


@Component({
  selector: 'edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditTemplateComponent extends BaseEditForm implements OnInit {

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditTemplateComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Template,
    private toast: ToastrService,) {
    super();
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.data?.nome, Validators.required],
      descrizione: [this.data?.descrizione],
      file: [],
      tipo_template: [this.data?.tipo_template,],
      stato_incarico: [this.data?.stato_incarico,],
      compagnia: [this.data?.compagnia,],
      studio: [this.data?.studio],
      doc_default_text: [this.data?.doc_default_text],
    });
  }

}

